var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "productTypeDialog",
      attrs: {
        "append-to-body": true,
        visible: _vm.chatGPTShow,
        "custom-class": "chatGPTDialog",
        "destroy-on-close": "",
        title: "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.chatGPTShow = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("MobileChat", {
        ref: "MobileChat",
        attrs: { programmeInfo: _vm.programmeInfo },
        on: { successfullyGenerated: _vm.successfullyGenerated },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }